<template>
  <div class="main_content">
    <div class="mapSearch">
      <!-- 搜索框 -->
      <div class="header flex-r" style="justifyContent:space-between;" :class="{ shadow: searching }">
        <el-input prefix-icon="el-icon-search" size="small" v-model="searchContent" placeholder="请输入设备名称/序列号"
          @focus="showContent()">
          <template slot="append">
            <el-button style="background:#437EDE;color:#fff" @click="search()">搜索</el-button>
          </template>
        </el-input>
      </div>
      <!-- 设备列表------------------>
      <div class="content" v-show="searching">
        <div class="nv">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(sit, index) in tabList" :key="index + sit.name" :label="sit.name" :name="sit.name">
              <!-- 展示已选中 -->
              <div class="selectedNum" :style="{ 'display': isCancel ? '' : 'none' }">
                <i class="el-icon-warning-outline"></i>
                <span style="padding-left:0.1rem">已选中{{ compareData.length }}/15</span>
              </div>
              <!-- 搜索结果------------------>
              <div class="searchResult">
                <!-- 父------------------>
                <div class="resultList"
                  v-for="(result, index) in (points.slice((paginationFile.current - 1) * paginationFile.size, paginationFile.current * paginationFile.size))"
                  :key="index" :class="{ check: check === result.code }">
                  <el-checkbox-group v-model="compareData" @change="selectDev">
                    <el-checkbox :label="result.code" :class="[isCancel ? '' : 'selectedBox']"
                      :disabled="result.type == '17' && $store.state.isCompare">
                      <div class="areaInfo flex-r" @click.stop.prevent="goSit(result.code)" v-if="points.length">
                        <div style="width:0.48rem;marginRight:16px;">
                          <img v-if="result.area_img" :src="result.area_img" />
                          <img :src="typeImg(result.typename)" v-else>
                        </div>
                        <div>
                          <h4 style="width:2.5rem;" class="ellipsis">{{ result.dname }}</h4>
                          <p style="width:2.5rem;" class="ellipsis">{{ result.address }}</p>
                        </div>
                      </div>
                    </el-checkbox>
                  </el-checkbox-group>
                  <!-- 子------------------>
                  <div class="sitInfo flex-r" v-show="false" style="background:rgba(255,255,255,0.15);padding:0.12rem;"
                    v-if="points.length">
                    <div style="width:0.48rem;marginLeft:0.64rem;marginRight:16px;">
                      <img src="../../assets/img/AQM65.png">
                    </div>
                    <div>
                      <h4 style="width:2rem;" class="ellipsis">{{ result.sitName }}</h4>
                      <p style="width:2rem;" class="ellipsis">{{ result.sitAddress }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 分页 -->
        <div style="text-align:center;padding:5px 0;">
          <a-pagination v-model="paginationFile.current" size="small" :total="paginationFile.total"
            @change="pageChange" />
        </div>
        <div class="compareBtn" v-if="$store.state.isCompare">
          <div class="tip"><i class="el-icon-info"></i>数据对比，设备最多选择15台</div>
          <el-button type="primary" size="mini" style="width:90%;margin-top:10px" @click="goCompare">查看数据对比</el-button>
        </div>
      </div>
    </div>
    <div class="compareDataBtn" v-if="isShowCompareBtn">
      <el-button-group style="margin-left: 26px">
        <el-button @click="goSelected" size="small" type="primary" icon="el-icon-circle-check" :style="{
          background: $store.state.isCompare ? '#437EDE' : '#405891', borderColor: $store.state.isCompare ? '#437EDE' : '#405891',
          'border-radius': $store.state.isCompare ? '0.06rem 0 0 0.06rem' : '0.06rem'
        }">数据对比</el-button>
        <el-button v-if="isCancel" @click="cancel" size="small" type="primary"
          style="margin-left: 0; border-radius: 0 0.06rem 0.06rem 0;" icon="el-icon-circle-close"
          :style="{ background: '#437EDE', borderColor: $store.state.isCompare ? '#437EDE' : '#405891' }">取消</el-button>
      </el-button-group>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
export default {
  props: ['positions', 'sitChecked'],
  data() {
    return {
      searchContent: '',  // 搜索框内容
      searching: false, // 是否展示设备列表
      activeName: '全部',
      tabList: [{  //设备列表tab
        checked: true,
        name: '全部'
      }],
      check: null,
      points: [],  // 设备列表
      isCancel: false, //  是否进行数据对比
      isShowCompareBtn: window.localStorage.getItem('roleId') !== '8',
      // 分页
      paginationFile: {
        current: 1,
        size: 10,
        total: 0,
      }
    }
  },
  methods: {
    // 点击设备
    goSit(code) {
      this.check = (this.check == code) ? null : code
      this.$bus.$emit('showCenter', code)
      // 数据对比模式下不展示右测设备数据详情
      if (this.isCancel) {
        this.$emit('isShowRight', false)
      }
    },
    // 搜索
    search() {
      this.points = this.positions.filter(item => {
        if (item.dname && item.address && item.name) {
          return item.dname.indexOf(this.searchContent) !== -1 || item.address.indexOf(this.searchContent) !== -1 || item.name.indexOf(this.searchContent) !== -1
        }
      })
      this.paginationFile.total = this.points.length
    },
    typeImg(type) {
      if (type == 'AQS小型空气站' || type == 'DS') {
        return require('../../assets/img/AQS.png')
      } else if (type == 'AQM小型空气站' || type == 'AQM-空气监测站') {
        return require('../../assets/img/AQM65.png')
      } else if (type == 'GR-OD异味监测') {
        return require('../../assets/img/GB.svg')
      } else {
        return require('../../assets/img/AQX.png')
      }
    },
    // 进入数据对比模式
    goSelected() {
      this.isCancel = true
      this.searching = true
      this.$message('请选择设备进行数据对比')
      this.$emit('isShowRight', false)  // 进行数据对比时不展示设备详情数据
    },
    // 取消数据对比
    cancel() {
      this.isCancel = false
      this.$emit('isShowRight', true)
    },
    selectDev(val) {
    },
    // 跳转至数据对比页面
    goCompare() {
      if (this.compareData.length == 0) {
        this.$message.warning('请选择需要对比的设备')
        return
      } else if (this.compareData.length > 15) {
        this.$message.warning('最多可选15台设备')
        return
      }
      this.$router.push({ path: '/compareData', query: { compareData: this.compareData } })
    },
    pageChange(page, pageSize) {
      this.paginationFile.current = page
    },
    showContent() {
      this.searching = true
    },
    handleClick(tab, event) {
      this.activeName = tab.name
    },
    // 关闭搜索结果
    closeSearch() {
      var app = document.getElementById('app')
      var self = this
      app.addEventListener('click', function () {
        self.searching = false
      })
    },
  },
  mounted() {
    // this.closeSearch()
  },
  watch: {
    activeName(value) {
      this.$nextTick(() => {
        let typeList = []
        this.sitChecked.forEach(item => {
          if (item.name == value) {
            typeList = item.type
          }
        });
        this.points = []
        this.positions.forEach(item => {
          typeList.forEach(j => {
            if (item.type == j) {
              this.points.push(item)
            }
          })
        })
        this.paginationFile.current = 1
        this.paginationFile.total = this.points.length
        if (value == '全部') {
          this.search()
        }
      })
    },
    sitChecked: {
      handler(val) {
        this.tabList = [{
          checked: true,
          name: '全部'
        }],
          val.forEach(item => {
            if (item.checked) {
              this.tabList.push(item)
            }
          })
      },
      deep: true,
      immediate: true
    },
    isCancel: {
      handler(val) {
        this.$store.dispatch('getStatus', val)
        // 若点击数据对比则不展示国控站tab
        if (val) {
          this.tabList = this.tabList.filter(item => item.name !== '国控站')
          this.activeName = '全部'
        } else {
          this.sitChecked.forEach(item => {
            if (item.checked && item.name == '国控站') {
              this.tabList.push(item)
            }
          })
        }
      }
    },
    searching(val) {
      this.$emit('showContent', val)
    },
    positions: {
      handler(val) {
        this.search()
      }
    }
  },
  computed: {
    compareData: {
      get() {
        return this.$store.state.compareData
      },
      set(val) {
        this.$store.dispatch('getCompareData', val)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.main_content {
  display: flex;

  .mapSearch {
    width: 280px;

    .header {
      z-index: 104;
      position: relative;
      overflow: hidden;
      min-height: 24px;
      border-radius: 0.06rem;

      ::v-deep .el-input__inner {
        background: #405891
      }

      ::v-deep .el-input__inner {
        border: 1px solid #405891;
        color: #fff;
      }

      ::v-deep .el-input-group__append {
        border: none;
      }
    }

    .shadow {
      box-shadow: 0px 1px 1px 1px rgba(0, 0, 0, 0.1);
    }

    .content {
      width: 100%;
      position: relative;
      padding-top: 0.26rem;
      min-height: 400px;
      background: #405891;
      border-radius: 0px 0px 0.06rem 0.06rem;
      transform: translateY(-0.2rem);
      z-index: 103;

      .nv {
        width: 100%;
        font-size: 0.12rem;
        padding: 0 5px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;

        .selectedNum {
          color: #93A6D2;
          border-bottom: 1px solid #364d84;
          height: 0.4rem;
          line-height: 0.4rem;
          padding-left: 0.1rem;
          font-size: 0.14rem
        }

        .searchResult {
          color: white;
          cursor: pointer;
          height: calc(5.5rem - 0.4rem);
          padding-bottom: 10px;
          overflow: auto;

          .resultList {
            border-bottom: 1px solid #364d84;

            ::v-deep.el-checkbox__input {
              padding-left: 10px;
            }

            .areaInfo {
              padding: 0.16rem 0.16rem 0.16rem 0;
            }
          }

          .check {
            background: #437EDE;
          }

          img {
            width: 100%;
            height: 100%;
            min-width: 34px;
            min-height: 34px;
          }

          h4 {
            margin: 0;
            font-size: 0.14rem;
            color: white;
            min-width: 140px;
          }

          p {
            font-size: 0.12rem;
            min-width: 140px;
            margin: 0;
            margin-top: 0.1rem;
            color: rgba(255, 255, 255, 0.6);
          }
        }

        .searchResult::-webkit-scrollbar {
          display: none;
          /* Chrome Safari */
        }

        .searchResult {
          scrollbar-width: none;
          /* Firefox */
          -ms-overflow-style: none;
          /* IE 10+ */
        }
      }

      .compareBtn {
        padding: 0 10px 10px 10px;
        text-align: center;

        .tip {
          font-size: 8px;
          text-align: right;
          color: #93A6D2;
        }
      }
    }
  }

  .compareDataBtn {
    ::v-deep .el-button--primary {
      color: #FFF;
    }
  }

  ::v-deep .el-tabs__header {
    padding: 0 12px;
    margin: 0;
  }

  ::v-deep .el-tabs__item {
    color: #fff;
    font-size: 0.14rem;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    background: #364d84;
  }

  .selectedBox {
    ::v-deep .el-checkbox__input {
      display: none;
    }
  }

  ::v-deep .ant-pagination-item-active {
    background: #437EDE;
    color: #fff;
    border-color: transparent;
  }

  ::v-deep .ant-pagination-item a {
    color: #fff;
  }

  ::v-deep .anticon {
    color: #fff;
  }

  ::v-deep .ant-pagination-item-ellipsis {
    color: #fff;
  }
}
</style>
